const versionStr = {
  1: 'basic',
  9: 'basic_pro',
  10: 'pro',
  11: 'ep',
  8: 'pro_trial' // 试用版
}
/**
 * 平台
 */
const plat = {
  all: 0,
  android: 1,
  ios: 2,
  js: 3
}
const platName = {
  0: 'all',
  1: 'android',
  2: 'ios',
  3: 'js'
}
/**
 * spa内需要维护的缓存数据key
 */
const storageKey = {
  appList: 'appList',
  currentApp: 'currentApp',
  userData: 'userData',
  queryParamCacheStr: 'queryParamCacheStr'
}
/**
 * 版本
 */
const versionCode = {
  basic: 1, // 基础版
  basic_pro: 9, // 基础试用版
  pro: 10,
  ep: 11,
  pro_trial: 8 // 试用版
}

// 地图支持的指标和细分
const mapUsable = {
  target: ['number', 'times', 'per', 'sum', 'avg'], // 人数、次数、人均次数、总和、均值
  dimension: ['area', 'city', 'current_area', 'current_city'] // 省份触发环境、城市触发环境、省份用户内置属性、城市用户内置属性
}
export {
  versionStr,
  plat,
  platName,
  storageKey,
  versionCode,
  mapUsable
}